const SINGULAR_KEYS = {
  days: "durationDay",
  weeks: "durationWeek",
  months: "durationMonth",
};

const PLURAL_KEYS = {
  days: "durationDays",
  weeks: "durationWeeks",
  months: "durationMonths",
};

/** Translate a parsed duration { count, unit } for the active locale. */
export const formatDuration = ({ count, unit }, t) => {
  const n = Number(count);
  const u = String(unit || "").toLowerCase();
  if (!Number.isFinite(n) || n < 1 || !PLURAL_KEYS[u]) return null;

  const templateKey = n === 1 ? SINGULAR_KEYS[u] : PLURAL_KEYS[u];
  return n === 1
    ? t(`prizes.${templateKey}`)
    : t(`prizes.${templateKey}`, { count: String(n) });
};

/** Translate duration from API stat fields (structured or legacy valueKey). */
export const formatDurationStat = (stat, t) => {
  if (stat?.durationCount != null && stat?.durationUnit) {
    const label = formatDuration(
      { count: stat.durationCount, unit: stat.durationUnit },
      t,
    );
    if (label) return label;
  }

  const match = String(stat?.valueKey || "").match(
    /^durationValues\.(\d+)_(days|weeks|months)$/,
  );
  if (match) {
    return formatDuration({ count: match[1], unit: match[2] }, t);
  }

  return null;
};

/** @deprecated Use formatDurationStat */
export const formatDurationValue = (valueKey, t) =>
  formatDurationStat({ valueKey }, t);
